import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import Spinner from "../../../components/common/spinner/Spinner";
import { Col, Container, Row, Button, Form } from "react-bootstrap";

import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import Api from "../../components/api/Api";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
// eslint-disable-next-line no-unused-vars
import { ChangePassword } from "./ChangePassword";
import { useSelector } from "react-redux";
import axios from "axios";

const EditUser = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const { userId } = useParams();
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  // eslint-disable-next-line no-unused-vars
  const userType = loggedInUser?.userDetails?.userType || loggedInUser?.userType;

  const roles = loggedInUser?.userDetails?.roles;
  console.log(roles);
  // eslint-disable-next-line no-unused-vars
  const userIdFromDatabase = loggedInUser?.userDetails?.id;
  console.log(userId);
  const getDetailsApi = Api({
    url: `admin/user/id/${userId}`,
  });
  const editDetailsApi = Api({
    url: `admin/editUser`,
  });
  const [formData, setFormData] = useState({
    id: userId,
    user_name: "",
    first_name: "",
    last_name: "",
    email_address: "",
    mobile_number: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        let userData = null;

        try {
          const res = await axios.get(`${baseUrl}/customer/customerDetail/${userId}`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          });
          const d = res.data;
          userData = d?.customerDetail || d?.customerDetails || d?.customer || (d?.first_name || d?.email_id ? d : d?.user);
        } catch (err) {
          const response = await getDetailsApi.fetchData();
          if (response?.data?.statusType === "SUCCESS") {
            userData = response.data?.user || response.data?.customer;
          }
        }

        if (userData) {
          setFormData((prev) => ({
            ...prev,
            user_name: userData.user_name || userData.first_name || "",
            first_name: userData.first_name || userData.user?.first_name || "",
            last_name: userData.last_name || userData.user?.last_name || "",
            email_address: userData.email_address || userData.email_id || userData.user?.email_address || userData.user?.email_id || "",
            mobile_number: userData.mobile_number || userData.mobile_no || userData.phone || userData.user?.mobile_number || "",
          }));
        }
      } catch (error) {
        setIsError(true);
        console.log(error);
        showToast("Error Occurred", {
          type: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = loggedInUser?.refreshToken;
      const baseUrl = process.env.REACT_APP_BASE_URL;
      let success = false;

      try {
        const res = await axios.put(
          `${baseUrl}/customer/editCustomer`,
          {
            id: userId,
            first_name: formData.first_name,
            last_name: formData.last_name,
            mobile_number: formData.mobile_number,
            email_id: formData.email_address,
          },
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        if (res.data?.statusType === "SUCCESS" || res.status === 200) {
          success = true;
        }
      } catch (err) {
        const responseData = await editDetailsApi.editData(formData);
        if (responseData?.data?.statusType === "SUCCESS") {
          success = true;
        }
      }

      if (success) {
        showToast("User Edited Successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/user");
        }, 1500);
      } else {
        showToast("Error Editing User", {
          type: "error",
        });
      }
    } catch (error) {
      setIsError(true);
      showToast("Error Occurred", {
        type: "error",
      });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Team Management", link: "/user" },
    { label: "Edit User Details", link: "", active: true },
  ];
  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Edit User Details"
              description="Edit User details section"
            />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Group controlId="userId">
                    <Form.Label>User ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="id"
                      value={formData.id}
                      disabled // Disable editing for userId
                    />
                  </Form.Group>
                </Col>
                {/* <Col>
                  <Form.Group controlId="user_name">
                    <Form.Label>User Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="user_name"
                      value={formData.user_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col> */}
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="first_name">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="last_name">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="email_address">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email_address"
                      value={formData.email_address}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="mobile_number">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" className="mt-5 mb-5">
                Update
              </Button>
              <Link
                style={{ marginLeft: "1rem" }}
                className="btn btn-primary mb-5 mt-5"
                to={"/user"}
              >
                Back
              </Link>
            </Form>
            {/* <Row>
              {userIdFromDatabase === +formData.id ? (
                <></>
              ) : (
                <>
                  <SingleDetailHeader header={"Change Password"} />
                  <ChangePassword />
                </>
              )}
            </Row> */}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditUser;
